export default __webpack_public_path__ + "static/media/photo9.427318de.jpg";